import React from "react";
import { StyleSheet, View } from "react-native";

import Icons from "../../common/icons/index";
import Toggle from "../../common/Toggle";
import AppTheme from "../../AppTheme";

export default function ReflectionHeaderChart({
  timeUnit,
  intervalColumns = [],
  showBackIcon,
  travelInTime = () => {},
  onPickerValueChanged = () => {},
}) {
  return (
    <View style={styles.container}>
      {/* Intervals */}
      <View style={styles.intervals}>
        {intervalColumns ? (
          <Toggle
            selected={timeUnit}
            options={intervalColumns}
            onToggle={(value) => onPickerValueChanged(value)}
            style={{
              backgroundColor: "#f3f2f1",
              height: 24,
              width: 260,
            }}
          />
        ) : null}
      </View>

      <View style={styles.rightContainer}>
        <Icons.ArrowLeft
          style={styles.arrowLeft}
          fillColor={AppTheme.iconBlack}
          onPress={() => travelInTime(-1)}
        />

        <Icons.ArrowRight
          style={[styles.arrowRight, { opacity: showBackIcon ? 1 : 0.5 }]}
          fillColor={AppTheme.iconBlack}
          onPress={() => travelInTime(1, showBackIcon)}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    height: 40,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    zIndex: 2,
    backgroundColor: AppTheme.headerBg,
    paddingLeft: 16,
    paddingRight: 12,
  },
  intervals: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    paddingRight: 10,
    flex: 1,
  },
  rightContainer: {
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    height: 40,
    minWidth: 40,
  },
  arrowLeft: {},
  arrowRight: {},
  gemStyles: {
    height: 35,
    width: 35,
    borderRadius: 35,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#FFF",
  },
});
